export default __webpack_public_path__ + "dc2b0540542ea68fb0b4880d0677692b.woff";